import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Per-page SEO meta tags. Drop into the top of any page component.
 *
 * Usage:
 *   <PageMeta
 *     title="Game Development Course | Job-Assured | AI School for All"
 *     description="Learn game development with Unity..."
 *     path="/game-development-course"
 *   />
 */
const PageMeta = ({
  title,
  description,
  path = '/',
  image = 'https://aischoolforall.com/brand/og-image.jpg',
  type = 'website',
}) => {
  const url = `https://aischoolforall.com${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default PageMeta;
